import { LitElement, html, css, unsafeCSS } from 'lit';
import { RDPropsetContainer } from '../Container/PropContainer.js';

import styles from './Number.css?raw';

export class propNumber extends RDPropsetContainer {
  static styles = [
    super.styles,
    css`
      ${unsafeCSS(styles)}
    `,
  ];
  static properties = {
    value: { type: String },
    disabled: { type: Boolean, reflect: true },
    placeholder: { type: String },
    step: { type: Number, reflect: true },
    min: { type: Number, reflect: true },
    max: { type: Number, reflect: true },
    onInput: { type: Function },
    onChange: { type: Function },
    callback: { type: Function },
  };
  constructor() {
    super();
    this.value = '';
    this.disabled = false;
    this.step = 1;
    this.min = -Infinity;
    this.max = Infinity;
    this.placeholder = 'auto';
    this.onInput = null;
    this.onChange = null;
    this.callback = null;
  }

  _onInput(e) {
    this.value = e.target.value;
    if (this.onInput && typeof this.onInput === 'function') {
      this.onInput.bind(this)(this.value || 0);
    }
    if (this.callback && typeof this.callback === 'function') {
      this.callback.bind(this)(this.value || 0);
    }
    this.dispatchEvent(new CustomEvent('prop-value-input', { detail: { value: this.value || 0 } }));
  }
  _onChange(e) {
    if (this.onChange && typeof this.onChange === 'function') {
      this.onChange.bind(this)(this.value || 0);
    }
    if (this.callback && typeof this.callback === 'function') {
      this.callback.bind(this)(this.value || 0);
    }
    this.value = e.target.value;
    this.dispatchEvent(new CustomEvent('prop-value-changed', { detail: { value: this.value || 0 } }));
  }

  _renderNumberInput() {
    return html`
      <div class="number-input">
        <input type="number" max="${this.max}" min="${this.min}" step="${this.step}" placeholder="${this.placeholder || ''}" .value="${this.value}" ?disabled="${this.disabled || this._partialDisabled}" @input="${this._onInput}" @change="${this._onChange}" />
      </div>
    `;
  }

  renderBody() {
    return html`<div class="option-container" tabindex="-1">${this._renderNumberInput()}</div>`;
  }
}
if (!customElements.get('rd-prop-number')) {
  customElements.define('rd-prop-number', propNumber);
}
